<template>
    <jet-form-section>
        <template #title>{{ $t("profile.email_preferences.title") }}</template>

        <template #description>{{
            $t("profile.email_preferences.description")
        }}</template>

        <template #form>
            <div class="gap-4 col-span-6 grid">
                <p v-if="failed" class="text-sm text-red-600">
                    {{ $t("profile.email_preferences.load_failed") }}
                </p>

                <div
                    v-for="topic of topics"
                    :key="topic"
                    class="gap-3 flex items-center justify-between"
                >
                    <div>
                        <Label :for="`topic-${topic}`">
                            {{
                                $t(
                                    `profile.email_preferences.topics.${topic}.label`,
                                )
                            }}
                        </Label>
                        <p class="text-sm text-iron-500 tracking-[-0.01em]">
                            {{
                                $t(
                                    `profile.email_preferences.topics.${topic}.description`,
                                )
                            }}
                        </p>
                    </div>

                    <Switch
                        :id="`topic-${topic}`"
                        :checked="subscriptions[topic] ?? false"
                        :disabled="loading || failed"
                        @update:checked="
                            (value: boolean) => toggle(topic, value)
                        "
                    />
                </div>
            </div>
        </template>
    </jet-form-section>
</template>

<script lang="ts" setup>
import JetFormSection from "../../Jetstream/FormSection.vue";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { onMounted, ref } from "vue";
import axios from "axios";
import route from "ziggy-js";

const topics = [
    "product_updates",
    "tips_onboarding",
    "newsletter",
    "promotions",
] as const;

const subscriptions = ref<Record<string, boolean>>({});
const loading = ref(true);
const failed = ref(false);

onMounted(async () => {
    try {
        const res = await axios.get(route("user.email-preferences.index"));

        if (!res.data.success) {
            failed.value = true;
            return;
        }

        subscriptions.value = res.data.data;
    } catch {
        failed.value = true;
    } finally {
        loading.value = false;
    }
});

async function toggle(topic: string, subscribed: boolean) {
    const previous = subscriptions.value[topic] ?? false;
    subscriptions.value = { ...subscriptions.value, [topic]: subscribed };

    try {
        const res = await axios.put(route("user.email-preferences.update"), {
            topic,
            subscribed,
        });

        if (!res.data.success) {
            subscriptions.value = {
                ...subscriptions.value,
                [topic]: previous,
            };
        }
    } catch {
        subscriptions.value = { ...subscriptions.value, [topic]: previous };
    }
}
</script>
